import { defineMessages } from 'react-intl';

export default defineMessages({
	coveredLivesHeading: {
		id: 'teams.coveredLives.heading',
		defaultMessage: 'See how affordable mental health support can be',
		description: 'Heading for the covered lives selector section',
	},
	coveredLivesSubHeading: {
		id: 'teams.coveredLives.subheading',
		defaultMessage:
			'Launch a proven mental health program with industry-leading engagement within minutes. Simply add the number of employees and start your checkout.',
		description: 'Subheading for the covered lives selector section',
	},
	yourInfoHeading: {
		id: 'teams.yourInfo.heading',
		defaultMessage: 'Hi, we just need a little information about you',
		description: 'Heading for info section',
	},
	companyInfoHeading: {
		id: 'teams.companyInfo.heading',
		defaultMessage: 'And, a little information about your organization',
		description: 'Heading for the company section',
	},
	paymentHeading: {
		id: 'teams.payment.heading',
		defaultMessage: 'Thank you for prioritizing your employees’ mental health',
		description: 'Heading for the payment section',
	},
});
